export default __webpack_public_path__ + "static/article-save-money-with-your-credit-card-26fa6d6e1e1f98d4e8856dd6491607be.jpg";